angular.module('jv.services')
    .service('App', ['$http', function($http){
        var App = {
            delimiter: '\n',
            /**
             * String to Array using delimiter (usually '\n')
             *
             * @param data {String}
             * @param [delimiter] {String} Optional delimiter, uses App.delimiter by default
             */
            serialize: function(data, delimiter) {
                if (!delimiter) {
                    delimiter = App.delimiter;
                }
                return data.join(delimiter);
            },
            //
            /**
             * Array to String using delimiter
             *
             * @param data {Array}
             * @param [delimiter] {String} Optional delimiter, uses App.delimiter by default
             */
            deserialize: function(data, delimiter) {
                if (!delimiter) {
                    delimiter = App.delimiter;
                }
                return data.trim(delimiter).split(delimiter);
            },
            /**
             * Create a serialized representation of an array or object,
             * suitable for use in a URL query string or Ajax request.
             *
             * @param obj {Array|Object} An array or object to serialize
             * @param [traditional] {Boolean} A Boolean indicating whether to perform a traditional 'shallow' serialization.
             *  Default: true
             */
            param: function(obj, traditional) {
                traditional = traditional || true;
                clone = angular.extend({}, obj);
                angular.forEach(clone, function(value, key){
                    if (value === undefined || value === null || value === '') {
                        delete clone[key];
                    }
                });
                return $.param(clone, traditional);
            },
            /**
             * ===BROKEN, RANGE ERROR===
             *
             * Wrapper for $xhr with supplements
             * refer to $xhr documentation for reference
             *
             * @link http://docs.angularjs.org/#!/api/angular.service.$xhr
             */
            xhr: function(method, url, data, callback) {
                if (angular.isFunction(data)) {
                    data = function(code, response) {
                        App.checkRedirect(response);
                        data(code, response);
                    };
                } else {
                    callback = function(code, response) {
                        App.checkRedirect(response);
                        callback(code, response);
                    };
                }
                return $xhr(method, url, data, callback);
            },
            /**
             * Check if authorized to access the page, otherwise redirect
             *
             * @param response  response object
             */
            checkAuth: function(response) {
                if (response.toString().indexOf('window.location') > 0) {
                    eval(response);
                }
            }
        };
        return App;
    }]
);